import { useMemo } from "react";

import { MultiSelectFilter } from "components/NewAdvancedSearch/filters/MultiSelectFilter";

// Legacy "grid" filters are a group of independent boolean flags — each
// component's key becomes `key=true` in the URL. Presenting the component list
// as a single multi-select preserves that behavior with one control; the flags
// are folded back into per-key params in buildQueryParams.
export function GridFilter({ descriptor, value, onChange }) {
  const optionsDescriptor = useMemo(
    () => ({
      ...descriptor,
      queryFn: undefined,
      data: descriptor.components.map(c => ({ id: c.key, name: c.title })),
    }),
    [descriptor]
  );

  return (
    <MultiSelectFilter
      descriptor={optionsDescriptor}
      value={value}
      onChange={onChange}
    />
  );
}
